import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { STORAGE_KEYS } from "./config"

// Tailwind class merger
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Token management
export function getToken() {
  return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
}

export function setToken(token) {
  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token)
}

export function removeToken() {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.USER_DATA)
}

export function logout() {
  removeToken()
  window.location.href = '/'
}

// Get auth headers
export function getAuthHeaders() {
  const token = getToken()
  return token ? {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  } : {}
}

// Format date
export function formatDate(dateString) {
  const date = new Date(dateString)
  const now = new Date()
  const diffInSeconds = Math.floor((now - date) / 1000)

  if (diffInSeconds < 60) return 'Just now'
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d ago`

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  })
}

// Truncate text
export function truncateText(text, maxLength = 150) {
  if (!text || text.length <= maxLength) return text
  return text.substring(0, maxLength).trim() + '...'
}

// Format number (1000 -> 1k)
export function formatNumber(num) {
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
  if (num >= 1000) return (num / 1000).toFixed(1) + 'k'
  return num.toString()
}

// Debounce function
export function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

// Check if user is authenticated
export function isAuthenticated() {
  const token = getToken()
  if (!token) return false

  try {
    // Basic JWT validation - check if token is expired
    const payload = JSON.parse(atob(token.split('.')[1]))
    const currentTime = Math.floor(Date.now() / 1000)

    // If token is expired, remove it and return false
    if (payload.exp && payload.exp < currentTime) {
      removeToken()
      return false
    }

    return true
  } catch (error) {
    // If token is malformed, remove it and return false
    removeToken()
    return false
  }
}

// Get view mode preference
export function getViewMode() {
  return localStorage.getItem(STORAGE_KEYS.VIEW_MODE) || 'card'
}

export function setViewMode(mode) {
  localStorage.setItem(STORAGE_KEYS.VIEW_MODE, mode)
}

// Generate unique ID for socket tracking
export function generateUniqueId() {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
}
